


































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import DeepCopy from '@/decorators/deep-copy';
import { IRules } from '../UI/Form/ValidationModule';
import { validateRequired, validateType } from '../UI/Form/Validations';
import { UNIT_SEARCH } from '@/queries/Unit';
import { GQL_pensionUnitSelection_pensionUnitSelection } from '@/queries/__generated__/pensionUnitSelection';
import UnitClosingDatesInfo from '@/components/Unit/UnitClosingDatesInfo.vue';

@Component({
  components: {
    UnitClosingDatesInfo,
  },
})
export default class PensionUnitSelectionForm extends Vue {
  @DeepCopy('data') private formData!: GQL_pensionUnitSelection_pensionUnitSelection;
  @Prop(Object) private data!: GQL_pensionUnitSelection_pensionUnitSelection;
  @Prop(Object) private query!: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  private UNIT_SEARCH = UNIT_SEARCH;
  private today = this.$dayjs().format('YYYY-MM-DD');

  private validForm = true;

  private rules: IRules = {
    pensionUnitId: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('PensionUnitSelection', 'pensionUnit') }),
      },
    ],
    validFrom: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('PensionUnitSelection', 'validFrom') }),
      },
      {
        validation: validateType('date'),
        message: i18n => i18n.t('GQL.Type.date'),
      },
    ],
    validTo: [
      {
        validation: ({ dataValue, formElements }) => {
          if (!dataValue || !formElements.validFrom) return true;
          return dataValue >= formElements.validFrom.dataValue;
        },
        message: i18n => i18n.t('Error.mustBeSameOrAfter', {
          beforeField: this.t_attr('PensionUnitSelection', 'validFrom'),
          afterField: this.t_attr('PensionUnitSelection', 'validTo'),
        }),
        triggerBy: [ 'validFrom' ],
      },
      {
        validation: validateType('date'),
        message: i18n => i18n.t('GQL.Type.date'),
      },
      {
        validation: ({ dataValue }) => {
          if (!dataValue || !this.data.minimalValidTo) return true;

          return this.$dayjs.strict(dataValue).isSameOrAfter(this.data.minimalValidTo);
        },
        message: i18n => i18n.t('Error.mustBeSameOrAfter', {
          beforeField: this.data.minimalValidTo,
          afterField: this.t_attr('PensionUnitSelection', 'validTo'),
        }),
      },
    ],
  };

  @Emit()
  private mutationDone() {}

  private get formatForMutation() {
    return {
      pensionUnitSelection: {
        ...this.formData,
        pensionUnit: undefined,
        isSentToAltinn: undefined,
        minimalValidTo: undefined,
      },
    };
  }
}
